<template>
  <v-app class="application--is-rtl main-app" app-data="true">
    <div @mousemove="mouseLeave">
      <NavBar />

      <Nuxt />

      <Footer />
      <Snackbar />
      <AlertDialog />
      <LeavePage ref="leavePageDialog" />
    </div>
  </v-app>
</template>
<script>
import NavBar from '@/components/NavigationMenu/NavBar';
import Footer from '@/components/Footer/Footer';
import Snackbar from '@/components/Snackbar/Snackbar';
import AlertDialog from '@/components/Dialogs/AlertDialog/AlertDialog';

import LeavePage from '@/components/Dialogs/LeavePage/LeavePage';

export default {
  name: 'LayoutRegisterSmartAlerts',
  components: {
    NavBar,
    Footer,
    Snackbar,
    AlertDialog,
    LeavePage,
  },
  data() {
    return {
      answer: false,
    };
  },
  methods: {
    /** detect mouse leave viewport */
    async mouseLeave(event) {
      if (
        event.clientY <= 5 ||
        event.clientX <= 0 ||
        event.clientX >= window.innerWidth ||
        event.clientY >= window.innerHeight
      ) {
        let answer = await this.$refs.leavePageDialog.pop();
        if (answer) {
          this.$router.push('/');
        } else {
          return false;
        }
      }
    },
  },
};
</script>
